export const environment = {
    production: true,
    host: "https://api.reports.re"
};